<template>
        <tr class="order-history-modal-message">
            <td class="date">
                {{ formattedDate }}
                <small v-if="displayTimeFromNow" class="time-from-now">({{ formattedDateFromNow}})</small>
            </td>
            <td class="creator">
                {{ history.creator }}
                <small v-if="history.creator_type">({{history.creator_type}})</small>
                <div class="small" v-if="history.validator">
                    <i class="fad fa-user-lock"></i> Action validée par <i>{{ history.validator }}</i>
                </div>
            </td>
            <td class="message">
                {{ history.message }}

                <template v-if="history.message_type == 'OrderUpdatedMessage'">
                    <OrderHistoryOrderUpdatedDetailsModal
                        v-if="history.context.diff"
                        :order="order"
                        :diff="history.context.diff"
                    />
                    <span v-else class="font-italic">(Aucun changement)</span>
                </template>
                <template v-if="history.message_type == 'OrderReturnedProductsUpdatedMessage'">
                    <OrderHistoryOrderReturnedProductsUpdatedDetailsModal
                        :order="order"
                        :context="history.context"
                    />
                </template>
            </td>
        </tr>
</template>

<script>
    import OrderHistoryOrderReturnedProductsUpdatedDetailsModal
        from "./OrderHistoryOrderReturnedProductsUpdatedDetailsModal"
    import OrderHistoryOrderUpdatedDetailsModal from "./OrderHistoryOrderUpdatedDetailsModal"

    export default {
        components: {
            OrderHistoryOrderReturnedProductsUpdatedDetailsModal,
            OrderHistoryOrderUpdatedDetailsModal,
        },

        props: {
            order: {
                type: Object,
                required: true,
            },
            history: {
                type: Object,
                required: true,
            },
            now: {
                type: Date,
                required: false,
            },
        },

        data() {
            return {
                momentDate: global.moment(this.history.created_at),
                momentNow: global.moment(this.now),
            };
        },

        computed: {
            formattedDate() {
                if (this.displayTimeFromNow) {
                    return this.momentDate.format('HH:mm:ss');
                }

                return this.momentDate.format('DD/MM/YYYY HH:mm:ss');
            },

            formattedDateFromNow() {
                return this.momentDate.from(this.momentNow);
            },

            displayTimeFromNow() {
                return this.momentDate.isSame(this.momentNow, 'day');
            },
        },

        watch: {
            now(newValue) {
                this.momentNow = global.moment(newValue);
            },
        },
    }
</script>

<style lang="scss">
    .order-history-modal-message {
        td {
            text-align: left;
        }

        .date {
            font-weight: bold;
            white-space: nowrap;
        }

        .creator {
            white-space: nowrap;
        }

        .time-from-now {
            font-weight: normal;
            font-style: italic;
        }

        .time-from-now:first-letter {
            text-transform: uppercase;
        }
    }
</style>
